import React, { ComponentClass, PureComponent, ReactNode } from "react";
import { Mutation } from "react-apollo";

import { ICart, ICartProductUpdateInput } from "../../../types/cart";
import { getCartFromCache } from "../../services/cart";

import { getOptimisticResponse } from "./cartProductUpdate.service";
import CartProductUpdate from "./graphql/CartProductUpdate";

export interface ICartProductUpdate {
  cartProductUpdate: (params: {
    variables: { input: ICartProductUpdateInput };
  }) => Promise<void>;
}

export default <P extends object>(
  Component: React.ComponentType<P>
): ComponentClass<P> =>
  class CartProductUpdateClass extends PureComponent<
    P & { cart?: ICart | null }
  > {
    public render(): ReactNode {
      return (
        <Mutation mutation={CartProductUpdate}>
          {(
            cartProductUpdate: (params: {
              optimisticResponse: object;
              variables: {
                input: ICartProductUpdateInput;
              };
            }) => void
          ): JSX.Element => {
            return (
              <Component
                {...this.props}
                cartProductUpdate={(params: {
                  optimisticResponse: object;
                  variables: { input: ICartProductUpdateInput };
                }): void => {
                  const cart = getCartFromCache();
                  const { productId, quantity } = params.variables.input;
                  const optimisticResponse = getOptimisticResponse(
                    cart,
                    productId,
                    quantity
                  );

                  return cartProductUpdate({
                    ...params,
                    optimisticResponse,
                  });
                }}
              />
            );
          }}
        </Mutation>
      );
    }
  };
